import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import RightContainer from "../../Partials/RightContainer"
import SideText from "./SideText"
import { Grid } from "./Grid"
import { fontSize } from "../../../styles/fonts/fontStyle"
import VerticalSpacer from "../../Partials/VerticalSpacer"

const IconList = ({ iconListItems = [], sideText }) => {
    return (
        <>
            <TextOneColumnOuterContainer>
                <TwoColumnsRightContainer>
                    <Grid>
                        <SideText copy={sideText} />
                        <ListContainer>
                            {iconListItems.map(
                                ({ id, text, src, alt, maxWidth }) => (
                                    <>
                                        <Li>
                                            <Icon
                                                src={src.publicURL}
                                                alt={alt}
                                                css={css`
                                                    max-width: ${maxWidth};
                                                `}
                                            />
                                            {text && (
                                                <>
                                                    <VerticalSpacer size="m" />
                                                    <IconText key={id}>
                                                        {text}
                                                    </IconText>
                                                </>
                                            )}
                                        </Li>
                                    </>
                                )
                            )}
                        </ListContainer>
                    </Grid>
                </TwoColumnsRightContainer>
            </TextOneColumnOuterContainer>
        </>
    )
}
export default IconList

const TextOneColumnOuterContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`
const ListContainer = styled.ul`
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 4rem;
    max-width: 800px;
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: grid;
`

const Li = styled.li`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: ${fontSize.minion};
    font-weight: 500;
`

const TwoColumnsRightContainer = styled(RightContainer)`
    justify-content: space-between;
`

const Icon = styled.img`
    max-width: 10rem;
    width: 100%;
`
const IconText = styled.span``
